module.exports = __webpack_public_path__ + "img/venuetwo-jkxwdk-active.096313cf.png";